exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lessMargin-a77d2548{margin:0 0 20px 0}.successMessage-5023b6af{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"lessMargin": "lessMargin-a77d2548",
	"successMessage": "successMessage-5023b6af"
};